import { render, staticRenderFns } from "./JobDataPanel.vue?vue&type=template&id=79b13bf8"
import script from "./JobDataPanel.vue?vue&type=script&lang=ts"
export * from "./JobDataPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports